import { Badge, Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./additem.scss";
import printicon from "../../../assets/images/print-icon.svg";
import threedothorizontal from "../../../assets/images/three-dots-horizontal.svg";
import duplicateicon from "../../../assets/images/duplicate-icon.svg";
import refreshIcon from "../../../assets/images/refresh-icon.svg";
import CustomModal from "../../../components/customModal/CustomModal";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import Select from "react-select";
import * as Yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import useInventory from "./../../../Hooks/useInventory";
import { LookUpModel } from "./popUpModels/LookUpModel";
import {
  handleNumberInput,
  itemPagesettingName,
  ndcRegex,
  toggleClass,
} from "../../../utils/commonUtils";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import Loading from "../../../components/LoadingPage/Loading";
import { useNavigate } from "react-router-dom";
import {
  ItemCreate,
  selectedInventoryItem,
  setSelectedItem,
  Units,
} from "../../../redux/inventory/inventorySlice";
import { OrderingProductsModel } from "./popUpModels/orderingProductsModel";
import { UseUnitsModel } from "./popUpModels/useUnitsModel";
import { DropDownValues } from "../../../utils/types";
import useProducts from "../../../Hooks/useProduct";
import DatePicker from "react-date-picker";
import React from "react";
import useSettings from "../../../Hooks/useSettings";
import { customFieldMetadataItem } from "../../../redux/customFields/customFieldsSlice";
import DynamicFields from "../../../components/DynamicFields/DynamicFields";
import {
  checkPermission,
  PermissionIdentifier,
  PermissionModule,
} from "../../../utils/permissionUtils";

type BarcodeValues = {
  useMfrBarcode: boolean;
  checkInternet: boolean;
  addNdcProductMaster: boolean;
  isMedicine: boolean;
  barcode: string;
};

const AddItem = ({ isUseFor, setIsUseFor }: any) => {
  const dispatch = useAppDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showUseUnitModal, setShowUseUnitModal] = useState(false);
  const [showCalcModal, setShowCalcModal] = useState(false);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [getuseUnitFieldVal, setGetuseUnitFieldVal] = useState("");
  const [useUnitTooltip, setUseUnitTooltip] = useState("");
  const selectedItem = useAppSelector(selectedInventoryItem);
  const customFieldsList = useAppSelector(customFieldMetadataItem);
  const [customFieldsConfig, setCustomFieldsConfig] = useState<any>([]);
  const [customFieldInitValues, setCustomFieldInitValues] = useState();
  const [customFieldInit, setCustomFieldInit] = useState(false);
  const {
    getItemDropdownVal,
    getNewBarcodeAPI,
    getNewBarcodeLoading,
    editInventoryItemAPI,
    getOrderingProductsAPI,
    getOrderingProductsLoading,
    editInventoryItemLoading,
    createItemDropdownvalLoading,
    barcodeDetailsLoading,
    getInventoryCountListAPI,
    createInventoryItemAPI,
    createInventoryItemLoading,
  } = useInventory();

  const [inventoryUnitOptions, setInventoryUnitOptions] = useState<
    DropDownValues[]
  >([]);
  const [rxTypes, setRxTypes] = useState<DropDownValues[]>([]);
  const { createProductAPI, createProductLoading } = useProducts();
  const [stocks, setStocks] = useState<DropDownValues[]>([]);
  const [orderingProdOptions, setOrderingProdOptions] = useState<
    DropDownValues[]
  >([]);
  const [usUnitsList, setUseUnitsList] = useState<any[]>([]);
  const [unitsList, setUnitsList] = useState<any[]>([]);
  const [unitIdReq, setUnitIdReq] = useState<string | null>(null);
  const [invUnitReqForUseUnit, setInvUnitReqForUseUnit] = useState<
    string | null
  >(null);
  const [inventoryCountList, setInventoryCountList] = useState<any[]>();
  const selectReqErr = "Select an option";
  const navigate = useNavigate();
  const submitActionRef = useRef<"save" | "saveAndExit">("save");
  const [tooltipText, setTooltipText] = useState("Copy to clipboard");
  const { getSettingsAPI, getSettingsLoading } = useSettings();
  const [settingsList, setSettingsList] = useState<any>([]);
  const DynamicInitialValues: ItemCreate = {
    rxName: "",
    drugName: "",
    manufacturer: "",
    ndcCode: "",
    serialNumber: "",
    lotNo: "",
    cvx: "",
    expiryDate: "",
    rxSRXId: "",
    notes: "",
    unitId: "",
    rxTypeId: "",
    stockId: "",
    cptCode: "0",
    isRecalled: false,
    isActive: true,
    orderingProductMasterId: null,
    createdBy: currentUserId,
    isNeverExpire: false,
    isKit: false,
    isSerialTracked: false,
    userDef1: "",
    userDef2: "",
    userDef3: "",
    userDef4: "",
    userDef5: "",
  };
  const DynamicValidation = {
    rxName: Yup.string().required("Item Name is Required"),
    rxSRXId: Yup.string()
      .required("SRX Barcode is Required")
      .max(75, "SRX Barcode should not be more than 75 characters"),
    drugName: Yup.string().required("Item Group is Required"),
    manufacturer: Yup.string().required("Manufacturer Name is Required"),
    ndcCode: Yup.string()
      .matches(ndcRegex, "Invalid NDC")
      .required("NDC is Required"),
    serialNumber: Yup.string(),
    lotNo: Yup.string().required("LOT Number is Required"),
    // expiryDate: Yup.string().required("Expiration Date is Required"),
    cvx: Yup.string(),
    unitId: Yup.string().required(selectReqErr),
    rxTypeId: Yup.string().required(selectReqErr),
    stockId: Yup.string().required(selectReqErr),
    cptCode: Yup.string().required("Cost is Required"),
    userDef1: Yup.string(),
    userDef2: Yup.string(),
    userDef3: Yup.string(),
    userDef4: Yup.string(),
    userDef5: Yup.string(),
  };
  const [itemValidationSchema, setItemValidationSchema] =
    useState<any>(DynamicValidation);
  const [renderItemLookUpPage, setRenderItemLookUpPage] =
    useState<BarcodeValues>({
      useMfrBarcode: false,
      checkInternet: true,
      addNdcProductMaster: true,
      isMedicine: false,
      barcode: "",
    });
  const [formInitialValues, setFormInitialValues] =
    useState(DynamicInitialValues);

  useEffect(() => {
    if (renderItemLookUpPage?.useMfrBarcode && renderItemLookUpPage?.barcode) {
      setValues((prev: any) => ({
        ...prev,
        rxSRXId: renderItemLookUpPage.barcode,
      }));
    }
  }, [renderItemLookUpPage]);

  const handleCostChange = (value: any) => {
    if (value.totalQuantity > 0 && value.price > 0) {
      return (value.price / value.totalQuantity).toFixed(4);
    }
  };
  const usUnits = (data: Units[]) => {
    setUseUnitsList(data);
  };
  const getSettings = () => {
    getSettingsAPI({ searchText: "" })
      .then((res: any) => {
        const settingsResult = res?.find(
          (option: any) =>
            option.settingName.toLowerCase() ===
            itemPagesettingName.toLowerCase()
        );
        setSettingsList(
          settingsResult
            ? JSON.parse(settingsResult?.settingValue?.toString())
            : []
        );
      })
      .catch();
  };
  const getLabels = (unitsList: DropDownValues[], unit: Units[]) => {
    let val = "";
    const getUnitId = inventoryUnitOptions?.find(
      (option) => option.value === itemValues.unitId
    )?.label;
    let tooltipVal = getUnitId ? `1 ${getUnitId} =` : "";
    unit.forEach((unit: Units) => {
      const unitVal = unitsList.find(
        (option: any) => option.value === unit.unitId
      );
      if (unitVal?.label) {
        val = val ? val + ", " + unitVal?.label : unitVal?.label;
        tooltipVal =
          tooltipVal + "<br/>" + unit.conversionFactor + " " + unitVal?.label;
      }
    });
    setUseUnitTooltip(tooltipVal);
    setGetuseUnitFieldVal(val);
  };
  const toggleCalcModal = () => {
    toggleClass();
    setShowCalcModal(!showCalcModal);
  };
  const toggleUseUnitModal = () => {
    toggleClass();
    setShowUseUnitModal(!showUseUnitModal);
  };
  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const setSelectedOPValue = (value: DropDownValues) => {
    setValues({
      ...itemValues,
      orderingProductMasterId: value.value,
    });
  };
  const checkUnitIdExists = () => {
    if (itemValues.unitId) {
      setUnitIdReq(null);
      toggleModal();
    } else {
      setUnitIdReq("Inventory Unit is required for this operation");
    }
  };
  const openUseUnitModel = () => {
    if (itemValues.unitId) {
      setInvUnitReqForUseUnit(null);
      toggleUseUnitModal();
    } else {
      setInvUnitReqForUseUnit("Inventory Unit is required for this operation");
    }
  };

  const redirectToListing = () => {
    if (isUseFor === "Edit") {
      setIsUseFor("View");
    } else {
      navigate("/inventory");
    }
  };

  const {
    handleChange: handleChangeCostCal,
    values: costCalValues,
    handleSubmit: costCalSubmit,
    touched: costCalTouched,
    errors: costCalErrors,
  } = useFormik({
    initialValues: {
      totalQuantity: 0,
      price: 0,
    },
    validationSchema: Yup.object({
      totalQuantity: Yup.number().required(),
      price: Yup.number().required(),
    }),
    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      setFormInitialValues({
        ...itemValues,
        ...(customFieldInitValues ?? {}),
        cptCode: (values.price / values.totalQuantity).toFixed(4),
      });
      toggleCalcModal();
      setSubmitting(false);
    },
  });

  const setFormBarcodeValues = (data: any) => {
    const newData = {
      ...itemValues,
      rxName: data.rxName,
      drugName: data.drugName,
      manufacturer: data.manufacturer,
      ndcCode: data.ndcCode,
      lotNo: data.lotNo,
      cvx: data.cvx,
      expiryDate: data.expiryDate,
    };
    setValues(newData);
    if (data.barcode) {
      setValues({
        ...newData,
        rxSRXId: data.barcode,
      });
    }
  };

  const {
    handleChange: handleChangeItem,
    values: itemValues,
    handleSubmit: itemSubmit,
    touched: itemTouched,
    errors: itemErrors,
    setValues,
  } = useFormik({
    initialValues: formInitialValues,
    validationSchema: Yup.object(itemValidationSchema),
    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      const customFieldData = customFieldsConfig.reduce(
        (acc: any, field: any) => {
          const key = field.name;
          if (key in values) {
            acc[key] = values[key];
            delete values[key];
          }
          return acc;
        },
        {}
      );
      values.customFieldValues = customFieldData;
      const { serialNumber, ...valuesWithoutSerial } = values;
      try {
        if (isUseFor === "Edit") {
          const editRes = await editInventoryItemAPI({
            ...valuesWithoutSerial,
            id: selectedItem.id,
            useUnits: usUnitsList,
            orderingProductMasterId: valuesWithoutSerial.orderingProductMasterId || null,
          });
          if (editRes?.rxSRXId) {
            dispatch(setSelectedItem(editRes));
            setCustomFieldInit(true);
          }
        } else {
          const res = await createInventoryItemAPI({
            ...valuesWithoutSerial,
            useUnits: usUnitsList,
            orderingProductMasterId: valuesWithoutSerial.orderingProductMasterId || null,
          });
          if (res?.success && res.result?.rxSRXId) {
            dispatch(setSelectedItem(res.result));
            navigator.clipboard.writeText(res.result.rxSRXId);
          }
          if (submitActionRef.current === "save" && res?.success) {
            navigate("/view-inventory");
            setSubmitting(false);
            return;
          }
        }
        redirectToListing();
      } catch (err: any) { }
      setSubmitting(false);
    },
    enableReinitialize: true,
  });
  const expiryToggleAction = (event: any) => {
    if (event.target.checked) {
      setItemValidationSchema({
        ...itemValidationSchema,
        expiryDate: Yup.string().nullable(),
      });
      setValues({
        ...itemValues,
        expiryDate: null,
      });
    } else {
      setItemValidationSchema(DynamicValidation);
    }
  };
  const invUnitChange = (unit: string) => {
    handleChangeItem("unitId")(unit);
  };
  useEffect(() => {
    getLabels(unitsList, usUnitsList);
  }, [usUnitsList, unitsList]);

  const handleCopy = () => {
    if (selectedItem?.rxSRXId) {
      navigator.clipboard
        .writeText(selectedItem.rxSRXId)
        .then(() => {
          setTooltipText("Copied!");
          setTimeout(() => setTooltipText("Copy to clipboard"), 1500);
        })
        .catch(() => {
          setTooltipText("Failed to copy");
        });
    }
  };

  const renderTooltip = useCallback(
    (props: any) => {
      if (isUseFor === "Edit") return null;

      const tooltipId =
        isUseFor === "View" ? "copy-tooltip" : "refresh-barcode-tooltip";
      const tooltipMessage =
        isUseFor === "View" ? tooltipText : "Refresh the barcode";

      return (
        <Tooltip id={tooltipId} {...props}>
          {tooltipMessage}
        </Tooltip>
      );
    },
    [isUseFor, tooltipText]
  );

  const getNewBarcode = async () => {
    await getNewBarcodeAPI().then((res: any) => {
      setCustomFieldInit(true);
      setFormInitialValues({
        ...formInitialValues,
        ...(customFieldInitValues || {}),
        rxSRXId: res,
      });
    });
  };
  const handleNumberInput = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;

    // Allow digits OR digits + dot (while typing) OR digits + dot + 1–4 digits
    const regex = /^\d+(\.\d{0,4})?$/;

    if (value === "" || regex.test(value)) {
      e.currentTarget.value = value;
    } else {
      e.currentTarget.value = value.slice(0, -1);
    }
  };

  const handleNumberBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    let value = e.currentTarget.value;

    // If user leaves trailing dot (e.g., "12.") → trim it to "12"
    if (/^\d+\.$/.test(value)) {
      value = value.slice(0, -1);
    }

    // If more than 4 decimals, trim them
    if (/^\d+\.\d{5,}$/.test(value)) {
      value = value.replace(/^(\d+\.\d{4}).*$/, "$1");
    }

    e.currentTarget.value = value;
  };

  useEffect(() => {
    if (isUseFor !== "Edit" && isUseFor !== "View") {
      getNewBarcode();
    }
    getOrderingProductsAPI({ includeDeleted: false, active: true }).then(
      (res: any) => {
        if (res) {
          setOrderingProdOptions([
            { value: "", label: "select..." },
            ...res.map((option: any) => ({
              value: option.id,
              label: `${option.productNo} - ${option.productDescription} (${option.unit.unitCode})`,
            })),
          ]);
        }
      }
    );
    getItemDropdownVal()
      .then((res: any) => {
        if (res) {
          setInventoryUnitOptions(
            res.units?.map((option: any) => {
              return {
                value: option.id,
                label: option.unitName,
              };
            })
          );
          setRxTypes(
            res.rxTypes?.map((option: any) => {
              return {
                value: option.id,
                label: option.rxTypeName,
              };
            })
          );

          setStocks(
            res.stocks?.map((option: any) => {
              return {
                value: option.id,
                label: option.stockName,
              };
            })
          );
          setUnitsList(
            res.units
              ?.map((option: any) => {
                return {
                  value: option.id,
                  label: option.unitName,
                };
              })
              .sort(
                (a: { sortOrder: number }, b: { sortOrder: number }) =>
                  a.sortOrder - b.sortOrder
              )
          );
          setRenderItemLookUpPage({
            ...res.itemPageSetting,
            barcode: formInitialValues.rxSRXId,
          });
        } else {
          setInventoryUnitOptions([]);
          setRxTypes([]);
          setStocks([]);
        }
      })
      .catch();
  }, []);

  useEffect(() => {
    if (isUseFor === "Edit" || isUseFor === "View") {
      if (isUseFor === "Edit") {
        setIsEdit(true);
      }
      if (selectedItem?.id) {
        setFormInitialValues({
          ...formInitialValues,
          rxName: selectedItem.rxName,
          drugName: selectedItem.drugName,
          manufacturer: selectedItem.manufacturer,
          ndcCode: selectedItem.ndcCode,
          serialNumber: selectedItem.serialNumber || "NA",
          lotNo: selectedItem.lotNo,
          cvx: selectedItem.cvx,
          expiryDate: selectedItem.expiryDate,
          rxSRXId: selectedItem.rxSRXId,
          notes: selectedItem.notes,
          unitId: selectedItem.unitId,
          rxTypeId: selectedItem.rxTypeId,
          stockId: selectedItem.stockId,
          cptCode: selectedItem.cptCode || "0",
          isRecalled: Boolean(selectedItem.isRecalled),
          isActive: Boolean(selectedItem.isActive),
          orderingProductMasterId: selectedItem.orderingProductMasterId ?? null,
          createdBy: currentUserId,
          isNeverExpire: selectedItem.isNeverExpire,
          isKit: Boolean(selectedItem.isKit),
          isSerialTracked: Boolean(selectedItem.isSerialTracked),
          userDef1: selectedItem.userDef1 || "",
          userDef2: selectedItem.userDef2 || "",
          userDef3: selectedItem.userDef3 || "",
          userDef4: selectedItem.userDef4 || "",
          userDef5: selectedItem.userDef5 || "",
        });
        setUseUnitsList(selectedItem.useUnits || []);
      } else {
        navigate("/inventory");
      }
      getInventoryCountListAPI(selectedItem.id).then((res: any) => {
        if (res) {
          setInventoryCountList(
            res.filter((x: { quantity: string }) => parseInt(x.quantity) !== 0)
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    getSettings();
  }, []);

  // Helper: Generate initial values from custom fields
  const getInitialValues = (fields: any[]) => {
    return fields.reduce((acc: any, field: any) => {
      acc[field.name] = field.value ?? "";
      return acc;
    }, {});
  };

  // Extract & set the custom fields config
  useEffect(() => {
    console.log("Extract & set the custom fields config");
    if (customFieldsList && customFieldsList.length > 0) {
      const customFields = customFieldsList
        .filter((item: any) => item?.customFieldModule?.name.toLowerCase() === "item")
        .map((item: any) => ({
          label: item?.name,
          name: item?.code,
          value: item?.defaultValue ?? "",
          type: item?.controlType?.name,
          isRequired: item?.isRequired,
          options:
            item?.allowedValues && typeof item?.allowedValues !== "string"
              ? JSON.parse(item.allowedValues)
              : [],
        }));
      setCustomFieldsConfig(customFields);
    }
  }, []);
  // Set initial form values when config is ready
  useEffect(() => {
    if (isUseFor === "Edit" || isUseFor === "View") {
      const customFieldInitialValues: Record<string, string> = {};

      customFieldsConfig.forEach((field: any) => {
        const fieldName = field.name;
        const selectedValue = selectedItem.customFieldValues?.[fieldName];
        customFieldInitialValues[fieldName] =
          selectedValue ?? field.value ?? "";
      });
      setFormInitialValues((prev: any) => ({
        ...prev,
        ...customFieldInitialValues,
      }));
    } else {
      const customFieldDefaultValues = getInitialValues(customFieldsConfig);
      setFormInitialValues((prev: any) => ({
        ...prev,
        ...customFieldDefaultValues,
      }));
    }
  }, [customFieldsConfig, customFieldInit]);

  // Set dynamic validation schema
  useEffect(() => {
    if (customFieldsConfig.length > 0) {
      const dynamicValidation = customFieldsConfig.reduce(
        (acc: any, field: any) => {
          let validator;

          if (
            field.type === "Numeric TextBox" ||
            field.type === "Decimal TextBox"
          ) {
            validator = Yup.number();
          } else {
            validator = Yup.string();
          }

          if (field.isRequired) {
            validator = validator.required(`${field.label} is required`);
          }

          acc[field.name] = validator;
          return acc;
        },
        {}
      );
      setItemValidationSchema((prev: any) => ({
        ...prev,
        ...dynamicValidation,
      }));
    }
  }, [customFieldsConfig]);

  const isInactivePermitted = checkPermission(
    PermissionModule.RX,
    PermissionIdentifier.INACTIVE_INVENTORY_ITEM
  );
  const isUseUnitsPermitted = checkPermission(
    PermissionModule.RX,
    PermissionIdentifier.MANAGE_USE_UNITS
  );

  return (
    <div className={`add-item-wrapper ${!isUseFor ? "create-form" : ""}`}>
      {createInventoryItemLoading ||
        createItemDropdownvalLoading ||
        editInventoryItemLoading ||
        barcodeDetailsLoading ||
        getNewBarcodeLoading ||
        getOrderingProductsLoading ||
        getSettingsLoading ||
        createProductLoading ? (
        <Loading />
      ) : null}
      <div className="page-title">
        <h2>{isUseFor === "View" ? "View" : isUseFor ? "Edit" : "Add"} Item</h2>
        {!isUseFor && (
          <Button
            onClick={handleShow}
            className="lookupbtn"
            variant="link"
            disabled={isUseFor || isEdit}
          >
            <ReactSVG className="svg-box" wrapper="span" src={printicon} />{" "}
            Lookup
          </Button>
        )}
      </div>
      <div className="add-item-box">
        <Form>
          <h5 className="form-section-title full-width">Basic Information</h5>
          <Form.Group className="mb-3 colspan2">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.ItemName
                ? settingsList.ItemLabels?.ItemName
                : "Item Name"}
              <sup>*</sup>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Item Name"
              id="rxName"
              name="rxName"
              onChange={(e) => handleChangeItem("rxName")(e.target.value ?? "")}
              value={itemValues.rxName}
              isInvalid={itemTouched.rxName && !!itemErrors.rxName}
              disabled={isUseFor === "View"}
            />
            {itemTouched.rxName && itemErrors.rxName ? (
              <Form.Control.Feedback type="invalid">
                {itemErrors.rxName}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.SrxBarcode
                ? settingsList.ItemLabels?.SrxBarcode
                : "SRX Barcode"}
            </Form.Label>
            <div className="input-with-button">
              <Form.Control
                type="text"
                placeholder="Enter Barcode"
                id="rxSRXId"
                name="rxSRXId"
                onChange={(e) =>
                  handleChangeItem("rxSRXId")(e.target.value ?? "")
                }
                value={itemValues.rxSRXId}
                isInvalid={itemTouched.rxSRXId && !!itemErrors.rxSRXId}
                disabled={isUseFor === "View"}
                style={{ fontWeight: "bold", color: "#044d6e" }}
              />
              {isUseFor !== "Edit" && (
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip}
                  delay={{ show: 250, hide: 400 }}
                >
                  <span
                    onClick={isUseFor === "View" ? handleCopy : getNewBarcode}
                    className="copy-icon"
                  >
                    <ReactSVG
                      className="svg-box"
                      wrapper="span"
                      src={isUseFor === "View" ? duplicateicon : refreshIcon}
                      style={{ width: "auto" }}
                    />
                  </span>
                </OverlayTrigger>
              )}
            </div>
            {itemTouched.rxSRXId && itemErrors.rxSRXId ? (
              <Form.Control.Feedback type="invalid">
                {itemErrors?.rxSRXId}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.ItemGroup
                ? settingsList.ItemLabels?.ItemGroup
                : "Item Group"}
              <sup>*</sup>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Item Group"
              id="drugName"
              name="drugName"
              onChange={(e) =>
                handleChangeItem("drugName")(e.target.value ?? "")
              }
              value={itemValues.drugName}
              isInvalid={itemTouched.drugName && !!itemErrors.drugName}
              disabled={isUseFor === "View"}
            />
            {itemTouched.drugName && itemErrors.drugName && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.drugName}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels &&
                settingsList?.ItemLabels?.Manufacturer
                ? settingsList.ItemLabels?.Manufacturer
                : "Manufacturer"}
              <sup>*</sup>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Manufacturer Name"
              id="manufacturer"
              name="manufacturer"
              onChange={(e) =>
                handleChangeItem("manufacturer")(e.target.value ?? "")
              }
              value={itemValues.manufacturer}
              isInvalid={itemTouched.manufacturer && !!itemErrors.manufacturer}
              disabled={isUseFor === "View"}
            />
            {itemTouched.manufacturer && itemErrors.manufacturer && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.manufacturer}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels &&
                settingsList?.ItemLabels?.OrderingProduct
                ? settingsList.ItemLabels?.OrderingProduct
                : "Ordering Product"}
              {isUseFor !== "View" && (
                <Badge
                  onClick={checkUnitIdExists}
                  bg="primary"
                  style={{ marginLeft: "5px" }}
                >
                  Add New
                </Badge>
              )}
            </Form.Label>
            <Select
              classNamePrefix="react-select"
              options={orderingProdOptions}
              id="orderingProductMasterId"
              name="orderingProductMasterId"
              value={orderingProdOptions?.find(
                (option: DropDownValues) =>
                  option.value === itemValues.orderingProductMasterId
              )}
              onChange={(option: any) =>
                handleChangeItem("orderingProductMasterId")(option.value)
              }
              className={`${itemTouched.orderingProductMasterId && !!itemErrors.orderingProductMasterId ? "is-invalid-border" : ""} react-select-container `}
              placeholder="Select"
              isDisabled={isUseFor === "View"}
            />
            {itemTouched.orderingProductMasterId &&
              itemErrors.orderingProductMasterId && (
                <Form.Control.Feedback type="invalid">
                  {itemErrors.orderingProductMasterId}
                </Form.Control.Feedback>
              )}
            {unitIdReq && (
              <Form.Control.Feedback type="invalid">
                {unitIdReq}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.Ndc
                ? settingsList.ItemLabels?.Ndc
                : "NDC"}
              <sup>*</sup>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter NDC"
              id="ndcCode"
              name="ndcCode"
              onChange={(e) =>
                handleChangeItem("ndcCode")(e.target.value ?? "")
              }
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^\d-]/g, "");
              }}
              value={itemValues.ndcCode}
              isInvalid={itemTouched.ndcCode && !!itemErrors.ndcCode}
              disabled={isUseFor === "View"}
            />
            {itemTouched.ndcCode && itemErrors.ndcCode ? (
              <Form.Control.Feedback type="invalid">
                {itemErrors.ndcCode}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.Lot
                ? settingsList.ItemLabels?.Lot
                : "LOT"}
              <sup>*</sup>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter LOT Number"
              id="lotNo"
              name="lotNo"
              onChange={(e) => handleChangeItem("lotNo")(e.target.value ?? "")}
              value={itemValues.lotNo}
              onInput={(e: any) => {
                e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
              }}
              isInvalid={itemTouched.lotNo && !!itemErrors.lotNo}
              disabled={isUseFor === "View"}
            />
            {itemTouched.lotNo && itemErrors.lotNo ? (
              <Form.Control.Feedback type="invalid">
                {itemErrors.lotNo}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels &&
                settingsList?.ItemLabels?.ExpirationDate
                ? settingsList.ItemLabels?.ExpirationDate
                : "Expiration Date"}
              <sup></sup>
            </Form.Label>
            <div className="input-with-button">
              <div className="calendar-box">
                <DatePicker
                  locale="en-US"
                  format="MM/dd/yyyy"
                  openCalendarOnFocus={false}
                  className={`${itemTouched.expiryDate && !!itemErrors.expiryDate
                    ? "is-invalid-border"
                    : ""
                    } form-control`}
                  value={itemValues.expiryDate}
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                  showLeadingZeros={true}
                  disabled={itemValues.isNeverExpire || isUseFor === "View"}
                  onChange={(date) =>
                    handleChangeItem({
                      target: { name: "expiryDate", value: date },
                    })
                  }
                  clearIcon={null}
                  calendarIcon={<i className="bi bi-calendar"></i>}
                />
              </div>
              <Form.Check
                className="isneverexpire"
                label="Does not Expire"
                type="checkbox"
                id="isNeverExpire"
                name="isNeverExpire"
                checked={itemValues.isNeverExpire}
                onChange={(event) => {
                  expiryToggleAction(event);
                  handleChangeItem(event);
                }}
                disabled={isUseFor === "View"}
              />
            </div>
            {itemTouched.expiryDate && itemErrors.expiryDate && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.expiryDate}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels &&
                settingsList?.ItemLabels?.InventoryUnit
                ? settingsList.ItemLabels?.InventoryUnit
                : "Inventory Unit"}
              <sup>*</sup>
            </Form.Label>
            <Select
              placeholder="Select"
              classNamePrefix="react-select"
              options={inventoryUnitOptions}
              id="unitId"
              name="unitId"
              value={inventoryUnitOptions?.find(
                (option) => option.value === itemValues.unitId
              )}
              onChange={(option: any) => {
                invUnitChange(option.value);
              }}
              className={`${itemTouched.unitId && !!itemErrors.unitId ? "is-invalid-border" : ""} react-select-container `}
              isDisabled={
                usUnitsList.length > 0 ||
                (inventoryCountList && inventoryCountList.length > 0) ||
                isUseFor === "View"
              }
            />
            {itemTouched.unitId && itemErrors.unitId && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.unitId}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UseUnits
                ? settingsList.ItemLabels?.UseUnits
                : "Use Units"}
            </Form.Label>
            <div className="input-with-button">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={
                  getuseUnitFieldVal ? (
                    <Tooltip className="custom-tooltip">
                      <p className="mb-0">
                        <span
                          dangerouslySetInnerHTML={{ __html: useUnitTooltip }}
                        />
                      </p>
                    </Tooltip>
                  ) : (
                    <></>
                  )
                }
                trigger={["hover", "focus"]}
              >
                <Form.Control
                  type="text"
                  placeholder="Enter Use Unit"
                  value={getuseUnitFieldVal}
                  isInvalid={!!invUnitReqForUseUnit}
                  disabled={true}
                />
              </OverlayTrigger>
              {isUseFor !== "View" && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Click to view or edit</Tooltip>}
                  trigger={isUseUnitsPermitted ? ["hover", "focus"] : []}
                >
                  <button
                    type="button"
                    className="use-unit-opt-btn"
                    onClick={openUseUnitModel}
                    disabled={!isUseUnitsPermitted}
                  >
                    <ReactSVG
                      className="svg-box"
                      wrapper="span"
                      src={threedothorizontal}
                    />
                  </button>
                </OverlayTrigger>
              )}
            </div>
            {invUnitReqForUseUnit && (
              <Form.Control.Feedback type="invalid">
                {invUnitReqForUseUnit}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.ItemType
                ? settingsList.ItemLabels?.ItemType
                : "Item Type"}
              <sup>*</sup>
            </Form.Label>
            <Select
              classNamePrefix="react-select"
              options={rxTypes}
              id="rxTypeId"
              name="rxTypeId"
              value={rxTypes?.find(
                (option) => option.value === itemValues.rxTypeId
              )}
              onChange={(option: any) =>
                handleChangeItem("rxTypeId")(option.value)
              }
              className={`${itemTouched.rxTypeId && !!itemErrors.rxTypeId ? "is-invalid-border" : ""} react-select-container `}
              placeholder="Select Item Type"
              isDisabled={isUseFor === "View"}
            />
            {itemTouched.rxTypeId && itemErrors.rxTypeId && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.rxTypeId}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.Stock
                ? settingsList.ItemLabels?.Stock
                : "Stock"}
              <sup>*</sup>
            </Form.Label>
            <Select
              classNamePrefix="react-select"
              options={stocks}
              id="stockId"
              name="stockId"
              value={stocks?.find(
                (option) => option.value === itemValues.stockId
              )}
              onChange={(option: any) =>
                handleChangeItem("stockId")(option.value)
              }
              className={`${itemTouched.stockId && !!itemErrors.stockId ? "is-invalid-border" : ""} react-select-container `}
              placeholder="Select"
              isDisabled={isUseFor === "View"}
            />
            {itemTouched.stockId && itemErrors.stockId && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.stockId}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <div className="item-checkbox-content">
              <Form.Check
                inline
                label={
                  settingsList?.ItemLabels && settingsList?.ItemLabels?.Active
                    ? settingsList.ItemLabels?.Active
                    : "Active"
                }
                type="checkbox"
                id="is_active"
                name="isActive"
                onChange={handleChangeItem}
                checked={itemValues.isActive}
                disabled={isUseFor === "View" || !isInactivePermitted}
              />
              <Form.Check
                inline
                label={
                  settingsList?.ItemLabels && settingsList?.ItemLabels?.Recall
                    ? settingsList.ItemLabels?.Recall
                    : "Recalled"
                }
                type="checkbox"
                id="is_recalled"
                name="isRecalled"
                onChange={handleChangeItem}
                checked={itemValues.isRecalled}
                disabled={isUseFor === "View"}
              />
              <Form.Check
                inline
                label={
                  settingsList?.ItemLabels && settingsList?.ItemLabels?.Kit
                    ? settingsList.ItemLabels?.Kit
                    : "Kit"
                }
                id="is_kit"
                name="isKit"
                type="checkbox"
                onChange={handleChangeItem}
                checked={itemValues.isKit}
                disabled={isUseFor === "View"}
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.CvxModel
                ? settingsList.ItemLabels?.CvxModel
                : "CVX/Model"}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter CVX/Model"
              id="cvx"
              name="cvx"
              onChange={(e) => handleChangeItem("cvx")(e.target.value ?? "")}
              value={itemValues.cvx}
              disabled={isUseFor === "View"}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UnitCost
                ? settingsList.ItemLabels?.UnitCost
                : "Unit Cost ($)"}
              <sup>*</sup>
            </Form.Label>
            <div className="input-with-button">
              <Form.Control
                type="text"
                placeholder="Enter Cost"
                id="cptCode"
                name="cptCode"
                onChange={(e) =>
                  handleChangeItem("cptCode")(e.target.value ?? "")
                }
                onInput={handleNumberInput}
                onBlur={handleNumberBlur}
                onClick={(e) => {
                  const input = e.target as HTMLInputElement;
                  input.select();
                }}
                value={itemValues.cptCode}
                isInvalid={itemTouched.cptCode && !!itemErrors.cptCode}
                disabled={isUseFor === "View"}
              />
              {isUseFor !== "View" && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Open Calculator</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <button type="button" onClick={toggleCalcModal}>
                    Calculate
                  </button>
                </OverlayTrigger>
              )}
            </div>
            {itemTouched.cptCode && itemErrors.cptCode && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.cptCode}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3 full-width">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.Notes
                ? settingsList.ItemLabels?.Notes
                : "Notes"}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              id="notes"
              name="notes"
              onChange={(e) => handleChangeItem("notes")(e.target.value ?? "")}
              value={itemValues.notes}
              isInvalid={itemTouched.notes && !!itemErrors.notes}
              disabled={isUseFor === "View"}
            />
            {itemTouched.notes && itemErrors.notes && (
              <Form.Control.Feedback type="invalid">
                {itemErrors.notes}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <h5 className="form-section-title full-width">Other Information</h5>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UserDef1
                ? settingsList.ItemLabels?.UserDef1
                : "User Def 1"}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter User Def 1"
              id="userDef1"
              name="userDef1"
              onChange={(e) => {
                handleChangeItem("userDef1")(e.target.value ?? "");
              }}
              value={itemValues.userDef1}
              disabled={isUseFor === "View"}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UserDef2
                ? settingsList.ItemLabels?.UserDef2
                : "User Def 2"}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter User Def 2"
              id="userDef2"
              name="userDef2"
              onChange={(e) => {
                handleChangeItem("userDef2")(e.target.value ?? "");
              }}
              value={itemValues.userDef2}
              disabled={isUseFor === "View"}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UserDef3
                ? settingsList.ItemLabels?.UserDef3
                : "User Def 3"}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter User Def 3"
              id="userDef3"
              name="userDef3"
              onChange={(e) => {
                handleChangeItem("userDef3")(e.target.value ?? "");
              }}
              value={itemValues.userDef3}
              disabled={isUseFor === "View"}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UserDef4
                ? settingsList.ItemLabels?.UserDef4
                : "User Def 4"}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter User Def 4"
              id="userDef4"
              name="userDef4"
              onChange={(e) => {
                handleChangeItem("userDef4")(e.target.value ?? "");
              }}
              value={itemValues.userDef4}
              disabled={isUseFor === "View"}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>
              {settingsList?.ItemLabels && settingsList?.ItemLabels?.UserDef5
                ? settingsList.ItemLabels?.UserDef5
                : "User Def 5"}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter User Def 5"
              id="userDef5"
              name="userDef5"
              onChange={(e) => {
                handleChangeItem("userDef5")(e.target.value ?? "");
              }}
              value={itemValues.userDef5}
              disabled={isUseFor === "View"}
            />
          </Form.Group>
          {customFieldsConfig.map((field: any) => (
            <DynamicFields
              field={field}
              isUseFor={isUseFor}
              handleChangeItem={handleChangeItem}
              itemValues={itemValues}
              itemErrors={itemErrors}
              itemTouched={itemTouched}
            />
          ))}
          {isUseFor !== "View" && (
            <Form.Group className="mb-3 full-width text-end">
              <Button
                style={{ marginRight: "10px" }}
                variant="outline-primary"
                onClick={redirectToListing}
              >
                Cancel
              </Button>
              {!isUseFor && (
                <Button
                  style={{ marginRight: "10px" }}
                  type="submit"
                  disabled={false}
                  onClick={(e) => {
                    submitActionRef.current = "saveAndExit";
                    (itemSubmit as any)(e);
                  }}
                >
                  Save & Exit
                </Button>
              )}
              <Button
                type="submit"
                disabled={false}
                onClick={(e) => {
                  submitActionRef.current = "save";
                  (itemSubmit as any)(e);
                }}
              >
                Save
              </Button>
            </Form.Group>
          )}
        </Form>
      </div>

      <LookUpModel
        show={show}
        handleClose={handleClose}
        setValues={setValues}
        renderItemLookUpPage={renderItemLookUpPage}
        setRenderItemLookUpPage={setRenderItemLookUpPage}
        setFormBarcodeValues={setFormBarcodeValues}
      />
      <OrderingProductsModel
        showModal={showModal}
        setSelectedOPValue={setSelectedOPValue}
        toggleModal={toggleModal}
        orderingProdOptions={orderingProdOptions}
        setOrderingProdOptions={setOrderingProdOptions}
        unitId={inventoryUnitOptions?.find(
          (option) => option.value === itemValues.unitId
        )}
      />

      <UseUnitsModel
        showUseUnitModal={showUseUnitModal}
        toggleUseUnitModal={toggleUseUnitModal}
        unitsList={unitsList}
        invUnitVal={
          inventoryUnitOptions?.find(
            (option) => option.value === itemValues.unitId
          )?.label
        }
        usUnitsList={usUnitsList}
        usUnits={usUnits}
      />
      {showCalcModal && (
        <CustomModal
          id="costcalcmodal"
          title="Cost Calculator"
          content={
            <div className="cost-calc-box">
              <Form onSubmit={costCalSubmit}>
                <div className="mb-4">
                  <Form.Group className="mb-3">
                    <Form.Label>Total Quantity</Form.Label>
                    <Form.Control
                      type="number"
                      min={1}
                      placeholder="Enter Total Quantity"
                      id="totalQuantity"
                      name="totalQuantity"
                      onChange={handleChangeCostCal}
                      value={costCalValues.totalQuantity}
                    />
                    {costCalTouched.totalQuantity &&
                      costCalErrors.totalQuantity && (
                        <Form.Control.Feedback type="invalid">
                          {costCalErrors.totalQuantity}
                        </Form.Control.Feedback>
                      )}
                  </Form.Group>
                </div>
                <div className="mb-2">
                  <Form.Group className="mb-3">
                    <Form.Label>Total Cost</Form.Label>
                    <Form.Control
                      type="number"
                      min={1}
                      placeholder="Enter Price"
                      id="price"
                      name="price"
                      onChange={handleChangeCostCal}
                      value={costCalValues.price}
                    />
                    {costCalTouched.price && costCalErrors.price && (
                      <Form.Control.Feedback type="invalid">
                        {costCalErrors.price}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>
                <div className="mb-2">
                  <label className="form-label">
                    Unit Cost : {handleCostChange(costCalValues)}
                  </label>
                </div>
                <div className="full-width text-end">
                  <Button
                    style={{ marginRight: "10px" }}
                    variant="outline-primary"
                    onClick={toggleCalcModal}
                  >
                    Cancel
                  </Button>
                  <Button type="submit">Use Cost</Button>
                </div>
              </Form>
            </div>
          }
          onClose={toggleCalcModal}
        />
      )}
    </div>
  );
};

export default AddItem;
